module.exports = __webpack_public_path__ + "img/category-favorite-hover.1d2a7d61.png";